<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Burn Marks</h1>
<p class="subtitle">A V.I. Warshawski Mystery</p>
<p class="author"><a id="page_iv">Sara Paretsky</a></p><a id="page_iv">
<div class="img_container">
<img alt="images" src="images/logo3.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?013e1391